import React from "react";
import classes from "./priceBreakup.module.scss";

const PriceBreakUp = (props) => {
    const { product, symbol, noIcon } = props
    const totalAmount = product.metal_price + product.diamond_price + product.gemstone_price + product.making_charge

    const inr = new Intl.NumberFormat('en-IN', { style: 'decimal' })

    const breakdownItems = [
        { label: "Metal Price", value: product.metal_price },
        { label: "Diamond Price", value: product.diamond_price },
        ...(product.gemstone_price ? [{ label: "Gemstone Price", value: product.gemstone_price }] : []),
        { label: "Making Charge", value: product.making_charge },
        { label: `GST (${product.gst}%)`, value: totalAmount * (product.gst / 100) },
    ]

    return (
        <div className={`uk-inline ${classes.price_breakup}`}>
            <button type="button" className={classes.trigger}>
                Price Breakup
                {!noIcon && <span className={classes.trigger_icon} />}
            </button>
            <div
                className={`uk-card uk-card-body uk-card-default ${classes.dropdown}`}
                data-uk-dropdown="animation: uk-animation-slide-top-small; animate-out: false; duration: 700; mode:click; container:true;boundary:true">
                <h4 className={classes.title}>Price Breakup</h4>
                <ul className={classes.breakdown_list}>
                    {breakdownItems.map((item, index) => (
                        <li key={index} className={classes.breakdown_item}>
                            <span className={classes.item_label}>{item.label}</span>
                            <span className={classes.item_value}>{symbol} {inr.format(item.value)}</span>
                        </li>
                    ))}
                </ul>
                <div className={classes.total_row}>
                    <span className={classes.total_label}>Total</span>
                    <div className={classes.total_value}>
                        <div className={classes.total_price}>{symbol} {inr.format(product.offerprice)}</div>
                        <div className={classes.tax_note}>MRP Inclusive of all taxes</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PriceBreakUp
